<template>
  <div
    class="sidenav-scroll collapse navbar-collapse"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav mt-4">
      <li class="nav-item px-2" v-if="loggedIn && meLoading">
        <div class="text-xs opacity-7 ps-4">
          Cargando menú...
        </div>
      </li>

      <li class="nav-item px-2" v-if="canVerAnalyticsParticipantes">
        <sidenav-collapse navText="Analytics Participantes" :to="{ name: 'AnalyticsParticipantes' }" @click="cerrarMenu()">
          <template #icon><box3d width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerAnalisisVentas">
        <sidenav-collapse navText="Análisis de Ventas" :to="{ name: 'AnalisisVentas' }" @click="cerrarMenu()">
          <template #icon><credit-card width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerInformes">
        <sidenav-collapse navText="Informes" :to="{ name: 'Informes' }" @click="cerrarMenu()">
          <template #icon><i class="fa fa-chart-bar" style="width:20px;text-align:center;font-size:14px"></i></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerMiUsuario">
        <sidenav-collapse navText="Mi usuario" :to="{ name: 'Profile' }" @click="cerrarMenu()">
          <template #icon><customer-support width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerPanel">
        <sidenav-collapse navText="Panel" :to="{ name: 'Dashboard' }" @click="cerrarMenu()">
          <template #icon><shop width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerPanelCliente">
        <sidenav-collapse navText="Panel Cliente" :to="{ name: 'PanelCliente' }" @click="cerrarMenu()">
          <template #icon><customer-support width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="canVerSolicitudesTipster">
        <sidenav-collapse navText="Solicitudes Tipster" :to="{ name: 'SolicitudesTipster' }" :badge="pendientesTipster" @click="cerrarMenu()">
          <template #icon><users width="20px" height="26px"/></template>
        </sidenav-collapse>
      </li>

      <!-- Sección Tipster -->
      <li class="nav-section-header px-3 mt-2" @click="tipsterOpen = !tipsterOpen" v-if="canVerCanales || canVerDescuentos || canVerDevoluciones || canVerPanelTipster || canVerPasarelas || canVerPedidos || canVerServicios">
        <span>Tipster</span>
        <i class="fas fa-chevron-down nav-section-chevron" :class="{ open: tipsterOpen }"></i>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerCanales">
        <sidenav-collapse navText="Canales" :to="{ name: 'Canales' }" @click="cerrarMenu()">
          <template #icon><switches width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerDescuentos">
        <sidenav-collapse navText="Descuentos" :to="{ name: 'Descuentos' }" @click="cerrarMenu()">
          <template #icon><credit-card width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerDevoluciones">
        <sidenav-collapse navText="Devoluciones" :to="{ name: 'Devoluciones' }" @click="cerrarMenu()">
          <template #icon><credit-card width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerPanelTipster">
        <sidenav-collapse navText="Panel Tipster" :to="{ name: 'PanelTipster' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerSuscripcionesTipster">
        <sidenav-collapse navText="Suscripciones" :to="{ name: 'SuscripcionesListaTipster' }" @click="cerrarMenu()">
          <template #icon><credit-card width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerCampanasTipster">
        <sidenav-collapse navText="Campañas" :to="{ name: 'CampanasTipster' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerPasarelas">
        <sidenav-collapse navText="Pasarelas" :to="{ name: 'Pasarelas' }" @click="cerrarMenu()">
          <template #icon><box3d width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerPedidos">
        <sidenav-collapse navText="Pedidos" :to="{ name: 'Pedidos' }" @click="cerrarMenu()">
          <template #icon><credit-card width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="tipsterOpen && canVerServicios">
        <sidenav-collapse navText="Servicios" :to="{ name: 'Productos' }" @click="cerrarMenu()">
          <template #icon><box3d width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>

      <!-- Sección Publicista -->
      <li class="nav-section-header px-3 mt-2" @click="publicistaOpen = !publicistaOpen" v-if="canVerPanelPublicista || canVerCampanas || canVerLandingServicios || canVerPersonalizacion">
        <span>Publicista</span>
        <i class="fas fa-chevron-down nav-section-chevron" :class="{ open: publicistaOpen }"></i>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerPanelPublicista">
        <sidenav-collapse navText="Panel Publicista" :to="{ name: 'PanelPublicista' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerCampanas">
        <sidenav-collapse navText="Campañas Afiliación" :to="{ name: 'Campanas' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerLandingServicios">
        <sidenav-collapse navText="Campañas Servicios" :to="{ name: 'CampanasServicios' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerCampanas">
        <sidenav-collapse navText="Landing Afiliación" :to="{ name: 'Landings' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerLandingServicios">
        <sidenav-collapse navText="Landing Servicios" :to="{ name: 'LandingServicios' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerPersonalizacion">
        <sidenav-collapse navText="Personalización" :to="{ name: 'PersonalizacionTipster' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="publicistaOpen && canVerCampanas">
        <sidenav-collapse navText="Publicidad Meta" :to="{ name: 'PublicidadMeta' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>

      <!-- Sección Configuraciones -->
      <li class="nav-section-header px-3 mt-2" @click="configOpen = !configOpen" v-if="canVerAsignacionTipstersAdmin || canVerConfiguracion || canVerMovimientos || canVerRoles || canVerTipsters || canVerUsuarios">
        <span>Configuraciones</span>
        <i class="fas fa-chevron-down nav-section-chevron" :class="{ open: configOpen }"></i>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerAsignacionTipstersAdmin">
        <sidenav-collapse navText="Asignación Tipsters" :to="{ name: 'AsignacionTipsters' }" @click="cerrarMenu()">
          <template #icon><users width="20px" height="26px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerConfiguracion">
        <sidenav-collapse navText="Configuración" :to="{ name: 'Configuracion' }" @click="cerrarMenu()">
          <template #icon><settings width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerConfiguracion">
        <sidenav-collapse navText="Países de venta" :to="{ name: 'PaisesVenta' }" @click="cerrarMenu()">
          <template #icon><settings width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerMovimientos">
        <sidenav-collapse navText="Registro de Movimientos" :to="{ name: 'RegistroMovimientos' }" @click="cerrarMenu()">
          <template #icon><box3d width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerRoles">
        <sidenav-collapse navText="Roles" :to="{ name: 'Roles' }" @click="cerrarMenu()">
          <template #icon><users width="20px" height="26px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerTipsters">
        <sidenav-collapse navText="Tipsters" :to="{ name: 'Tipsters' }" @click="cerrarMenu()">
          <template #icon><spaceship width="20px" height="20px"/></template>
        </sidenav-collapse>
      </li>
      <li class="nav-item px-2" v-if="configOpen && canVerUsuarios">
        <sidenav-collapse navText="Usuarios" :to="{ name: 'Usuarios' }" @click="cerrarMenu()">
          <template #icon><users width="20px" height="26px"/></template>
        </sidenav-collapse>
      </li>

    </ul>
  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import api from "@/services/apiClient.js";
//import SidenavCard from "./SidenavCard.vue";
import Shop from "../../components/Icon/Shop.vue";
//import Office from "../../components/Icon/Office.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
import Box3d from "../../components/Icon/Box3d.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Switches from "../../components/Icon/Switches.vue";
import Spaceship from "../../components/Icon/Spaceship.vue";
import Settings from "../../components/Icon/Settings.vue";
import Users from "../../components/Icon/Users.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      pendientesTipster: 0,
      configOpen: false,
      publicistaOpen: false,
      tipsterOpen: false,
    };
  },

  watch: {
    canVerSolicitudesTipster(val) {
      if (val) this.cargarPendientesTipster();
    },
    permisos(val) {
      if (!Array.isArray(val)) return;
      this.aplicarSeccionesPorRol();
    },
  },

  mounted() {
    this.$nextTick(() => this.aplicarSeccionesPorRol());
  },
  computed: {
    loggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    meLoading() {
      return !!this.$store.state.auth?.meLoading;
    },

    permisos() {
      // Mientras carga, devolvemos null para distinguir de "sin permisos"
      if (this.meLoading) return null;
      return this.$store.state.auth?.permisos_finales || [];
    },

    rolEfectivo() {
      return this.$store.getters['auth/rolEfectivo'];
    },

    esTipster() {
      return Number(this.rolEfectivo) === 4;
    },

    // helpers de permisos (computed porque se re-evalúa solo)
//    canVerPanel() { return this.permisos.includes("dashboard.ver"); },
//    canVerMiUsuario() { return this.permisos.includes("mi_usuario.ver"); },
//    canVerTipsters() { return this.permisos.includes("tipsters.ver"); },
//    canVerUsuarios() { return this.permisos.includes("usuarios.ver"); },
//    canVerAsignacionTipsters() { return this.permisos.includes("asignacion_tipsters.ver"); },
//    canVerCanales() { return this.permisos.includes("canales.ver"); },
//    canVerCampanas() { return this.permisos.includes("campanas.ver"); },
//    canVerServicios() { return this.permisos.includes("productos.ver"); },
//    canVerDescuentos() { return this.permisos.includes("descuentos.ver"); },
//    canVerPedidos() { return this.permisos.includes("pedidos.ver"); },
//    canVerConfiguracion() { return this.permisos.includes("configuracion.ver"); },
    canVerPanel() { return [1, 2].includes(this.rolEfectivo); },
    canVerMiUsuario() { return Array.isArray(this.permisos) && this.permisos.includes("mi_usuario.ver"); },
    canVerTipsters() { return Array.isArray(this.permisos) && this.permisos.includes("tipsters.ver"); },
    canVerUsuarios() { return Array.isArray(this.permisos) && this.permisos.includes("usuarios.ver"); },
    canVerAsignacionTipsters() { return Array.isArray(this.permisos) && this.permisos.includes("asignacion_tipsters.ver"); },
    canVerAsignacionTipstersAdmin() {
      return this.canVerAsignacionTipsters;
    },
    canVerPanelCliente() {
      return Array.isArray(this.permisos) && this.permisos.includes("cliente.dashboard.ver");
    },

    // Publicista (y admin) ven Panel Publicista
    canVerPanelPublicista() {
      return Array.isArray(this.permisos) && this.permisos.includes("panel_publicista.ver");
    },
    canVerPanelTipster() {
      return Array.isArray(this.permisos) && this.permisos.includes("panel_tipster.ver");
    },
    canVerCampanasTipster() {
      return Array.isArray(this.permisos) && this.permisos.includes("tipster.campanas.ver");
    },
    canVerSuscripcionesTipster() {
      return Array.isArray(this.permisos) && (
        this.permisos.includes("panel_tipster.ver") ||
        this.permisos.includes("tipster.suscripciones.ver")
      );
    },
    canVerAnalyticsParticipantes() {
      return Array.isArray(this.permisos) && this.permisos.includes("analytics.participantes.ver");
    },
    canVerAnalisisVentas() {
      return Array.isArray(this.permisos) && this.permisos.includes("analytics.ventas.ver");
    },

    canVerCanales() { return Array.isArray(this.permisos) && this.permisos.includes("canales.ver"); },
    canVerCampanas() { return Array.isArray(this.permisos) && this.permisos.includes("campanas.ver"); },
    canVerServicios() { return Array.isArray(this.permisos) && this.permisos.includes("productos.ver"); },
    canVerDescuentos() { return Array.isArray(this.permisos) && this.permisos.includes("descuentos.ver"); },

    canVerPedidos() { return Array.isArray(this.permisos) && this.permisos.includes("pedidos.ver"); },
    canVerDevoluciones() {
      return Array.isArray(this.permisos) && this.permisos.includes("devoluciones.ver");
    },
    canVerPasarelas() {
      return Array.isArray(this.permisos) && this.permisos.includes("pasarelas.ver");
    },
    canVerComisiones() {
      return Array.isArray(this.permisos) && this.permisos.includes("comisiones.ver");
    },
    canVerConfiguracion() { return Array.isArray(this.permisos) && this.permisos.includes("configuracion.ver"); },
    canVerRoles() {
      return Array.isArray(this.permisos) && (
        this.permisos.includes("roles.ver") ||
        this.permisos.includes("permisos.ver")
      );
    },
    canVerMovimientos() {
      return Array.isArray(this.permisos) && this.permisos.includes("movimientos.ver");
    },
    canVerInformes() {
      return Array.isArray(this.permisos) && this.permisos.includes("informes.ver");
    },
    canVerMetricasNegocio() {
      return [1, 2].includes(this.rolEfectivo);
    },
    canVerPersonalizacion() {
      return Array.isArray(this.permisos) && this.permisos.includes("personalizacion_tipster.ver");
    },
    canVerSolicitudesTipster() {
      return Array.isArray(this.permisos) && this.permisos.includes("solicitudes_tipster.ver");
    },
    canVerLandingServicios() {
      return Array.isArray(this.permisos) && this.permisos.includes("producto_landings.ver");
    },
  },


  components: {
    SidenavCollapse,
  //  SidenavCard,
    Shop,
  //  Office,
    CreditCard,
    Box3d,
    CustomerSupport,
    Switches,
    Users,
  //  Document,
    Spaceship,
    Settings,
  },
  methods: {
    aplicarSeccionesPorRol() {
      if (!Array.isArray(this.permisos)) return;
      if (Number(this.rolEfectivo) === 1) return; // admin: todo cerrado
      this.tipsterOpen    = this.canVerCanales || this.canVerDescuentos || this.canVerDevoluciones || this.canVerPanelTipster || this.canVerPasarelas || this.canVerPedidos || this.canVerServicios;
      this.publicistaOpen = this.canVerPanelPublicista || this.canVerCampanas || this.canVerLandingServicios || this.canVerPersonalizacion;
      this.configOpen     = false;
    },

    cerrarMenu() {
      this.$store.state.mostrarMenuLateral = false;
      document.getElementById("app").classList.remove("rtl");
    },

    async cargarPendientesTipster() {
      if (!this.canVerSolicitudesTipster) return;
      try {
        const { data } = await api.get('/api/v2/solicitudes-tipster/pendientes');
        this.pendientesTipster = data.pendientes || 0;
      } catch {
        // silencioso — no rompe el sidebar
      }
    },
  },
};
</script>
<style scoped>
  /* El scroll del sidenav lo gestiona global.css con flex + min-height:0 */
  .sidenav-scroll {
    overflow-x: hidden !important;
  }
  .sidenav-scroll .navbar-nav {
    padding-bottom: 2rem;
  }

  .nav-section-header {
    list-style: none;
    padding-top: 8px;
    padding-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    user-select: none;
  }
  .nav-section-header span {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--q-gold, #c9a84c);
  }
  .nav-section-chevron {
    font-size: 10px;
    color: var(--q-gold, #c9a84c);
    transition: transform 0.2s ease;
  }
  .nav-section-chevron.open {
    transform: rotate(180deg);
  }
</style>